export default __webpack_public_path__ + "static/media/collapse-all.e36ec1ab.svg";